/**
 * 默认所有非列表栏目都使用该组件（富文本栏目使用），未做列表混合
 */
<template>
    <div class="about">
        <PageTitle :title="name"/>
        <section id="single_Service" class="sec-padding">
        	<div class="container">
        		<div class="row">
                    <!--侧边栏  -->
                    <PageAside v-if="!isFull" :list="columns" :active="active" @tabClick="tabClick"/>
                    <!-- 主体内容 -->
                    <div v-if="detail" class="col-lg-9 col-md-9" v-html="detail"></div>
                    <!-- 没有数据 -->
                    <div v-else class="text-center">暂无数据</div>
        		</div>
        	</div>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/common/PageTitle.vue";
    import PageAside from "@/components/common/PageAside.vue";
    import mixins from "@/assets/mixins/normalMixins.js";
    export default {
        name: "page-content",
        props: ['name'],
        mixins: [mixins],
        components:{
            PageTitle,
            PageAside
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageContent.vue